import React, { useEffect } from 'react';
import PDFObject from 'pdfobject';
const AllPages = (props) => {
  console.log("props",props.pdf);
  
  useEffect(() => {
    PDFObject.embed(props.pdf, "#pdf-viewer");
  }, [props.pdf]);

  return <div id="pdf-viewer" style={{ height: '750px',width:'950px' }} />;
};

export default AllPages;
